<template>
	<div class="app" style="width: 100%;">
		<el-container direction="vertical">
			<el-header style="padding:0;height: auto">
				<IndexHead style="width:100%;"></IndexHead>
			</el-header>
			<el-main style="padding:0;">
				<div class="text flex justify-align-center direction-column"
					style="font-size: 23px;height:85px;margin-top: 10px;margin-bottom: 10px ;">
					网站简介
					<div style="color:#aaaaaa;font-size: 20px;margin-top: 5px;">WANGZHANJIANJIE</div>
				</div>
				<div class="content font flex direction-column align-center space-between"
					style="width:55%;margin: 0 auto;height: 60px;text-align: center;">
					<!-- <span>HR校招助手是一家为全国 HR 解决校招难题的网站。本站可以按地域、专业、学历层次、院校类型、上级单位、院校特性查询全国</span>
				  <span>2700所院校,就业办电话、生源信息、校招指南、最新双选会信息;开通298元 VIP 会员后,可以</span>
				  <span>不限量使用搜索功能,报名全国所有校园双选会,查询院校就业负责人手机号</span> -->
					<div>{{contact.brief}}</div>
				</div>
				<el-row justify="center" style="margin: 30px 0;text-align: center;">
					<img src="../assets/img/hz2.png" style="width:640px;height: auto" />
				</el-row>
				<!-- <div style="margin:30px auto;width:37%;">
					
				</div> -->
				<div style="margin:30px auto;width:100%;">
					<img src="../assets/img/ab1.png" style="width:100%;height: auto" />
				</div>
				<div style="margin:30px auto;width:60%;">
					<div class="text flex justify-align-center direction-column"
						style="font-size: 23px;height:85px;margin-top: 10px;margin-bottom: 10px ;">
						企业文化
						<div style="color:#aaaaaa;font-size: 20px;margin-top: 5px;">QIYEWENHUA</div>
					</div>
					<div class="flex">
						<img src="../assets/img/hz1.png" style="width:49%;height:auto" />
						<div style="margin-left: 30px;" class="flex direction-column justify-center">
							<div class="flex direction-column " style="text-align: left;">
							 <div style="font-size: 14px;">使命：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{culture.mission}}</div>
							</div>
							<div class="flex direction-column " style="text-align: left;margin-top:20px;">
								<div style="font-size: 14px;">愿景：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{culture.vision}}</div>
							</div>
						</div>
					</div>
					<div class="text flex justify-align-center direction-column"
						style="font-size: 23px;height:85px;margin-top: 15px;margin-bottom: 15px ;">
						联系方式
						<div style="color:#aaaaaa;font-size: 20px;margin-top: 5px;">LIANXIFANGSHI</div>
					</div>
					<div class="flex">
						<div style="margin-right: 20px;width: 49%;" class="flex align-center row_wrap">
							<div class="flex direction-column " style="text-align: left;width:50%;">
								<div style="font-size: 14px;">联系人：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{contact.user_name}}</div>
							</div>
							<div class="flex direction-column " style="text-align: left;width:50%;">
								<div style="font-size: 14px;">手机：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{contact.mobile}}</div>
							</div>
							<div class="flex direction-column " style="text-align: left;width:50%;">
						 	<div style="font-size: 14px;">微信：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{contact.wx}}</div>
							</div>
							<div class="flex direction-column " style="text-align: left;width:50%;">
								<div style="font-size: 14px;">邮箱：</div>
								<div class="font" style="color:#999999;margin-top: 10px;">{{contact.email}}</div>
							</div>
						</div>
						<img src="../assets/img/hz1.png" style="width:49%;height:auto" />
					</div>
				</div>
			</el-main>
			<el-footer style="padding:0;height: 30px;margin-top: 60px;width:100%;">
				<div class="font flex justify-align-center"
					style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;">
					版权所有：HR校招助手网 <span style="width: 100px;display: inline-block;"></span> CNZZ
				</div>
			</el-footer>
		</el-container>
		<div style="height: 50px;width: 100%;"></div>
	</div>
</template>

<script>
	import IndexHead from '../components/IndexHead.vue';
	export default {
		name: 'index',
		components: {
			IndexHead
		},
		data() {
			return {
				culture: {
					mission: '用科技为HR提供校招信息，提升HR的招聘效率',
					vision: '成为全国HR校园招聘的最好助手',
				},
				contact: {
					name: '孙先生',
				 tel: '18612987693',
					wxin: '18612987693',
					email: '1500493835@qq.com'
				}
			}
		},
		mounted() {
			this.cooperat();
		},
		methods: {
			cooperat() {
				this.$axios
					.get(`/api/about`)
					.then((res) => {
						// console.log(res,"res");
						this.contact = res.data.data;
					});
			}
		}
	}
</script>
<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #2c3e50;
	}

	#navs {
		display: flex;
		justify-content: space-around;
	}

	#nav {
		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
</style>
